"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentContractNumberChangeActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const KeyValueDisplay_1 = require("./KeyValueDisplay");
const ShipmentContractNumberChangeActivity = (props) => {
    const theme = (0, silhouette_core_1.useTheme)();
    const { activity: { contractNumberChanges }, } = props;
    if (!contractNumberChanges) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { color: theme.palette.menu.default, children: [(0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: "Old contract number", value: contractNumberChanges?.from }, "old-contract-number"), (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: "New contract number", value: contractNumberChanges?.to }, "new-contract-number")] }));
};
exports.ShipmentContractNumberChangeActivity = ShipmentContractNumberChangeActivity;
//# sourceMappingURL=ShipmentContractNumberChangeActivity.js.map